import script from "./Msf.vue?vue&type=script&setup=true&lang=js"
export * from "./Msf.vue?vue&type=script&setup=true&lang=js"

import "./Msf.vue?vue&type=style&index=0&id=0189c35c&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0189c35c"]])

export default __exports__